var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['entry-diff', _vm.diffType]},[(_vm.showArrow)?_c('span',[_c('i',{staticClass:"fas fa-caret-down"})]):_vm._e(),_vm._v(" "+_vm._s(_vm.absoluteDiff)+" "+_vm._s(_vm.unit)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }